import { useEffect, useRef } from 'react';
import { useAuth } from './useAuth';
import api from '../services/api';

const INACTIVITY_TIMEOUT = 10 * 60 * 1000;
const HEARTBEAT_INTERVAL = 30 * 1000;

export const useActivityMonitor = () => {
  const { logout, token, refreshPermissions } = useAuth();
  const lastActivityRef     = useRef(Date.now());
  const heartbeatIntervalRef = useRef(null);
  const checkIntervalRef    = useRef(null);
  const logoutRef           = useRef(logout);
  const refreshRef          = useRef(refreshPermissions);

  // Keep refs current without re-running the effect
  useEffect(() => { logoutRef.current  = logout; },           [logout]);
  useEffect(() => { refreshRef.current = refreshPermissions; }, [refreshPermissions]);

  useEffect(() => {
    if (!token) return;

    const updateActivity = () => { lastActivityRef.current = Date.now(); };
    updateActivity();

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, updateActivity));

    heartbeatIntervalRef.current = setInterval(async () => {
      try {
        const res = await api.post('/heartbeat');
        if (res?.data?.permissions) refreshRef.current(res.data.permissions);
      } catch { /* silent */ }
    }, HEARTBEAT_INTERVAL);

    checkIntervalRef.current = setInterval(() => {
      if (Date.now() - lastActivityRef.current >= INACTIVITY_TIMEOUT) {
        logoutRef.current();
      }
    }, 10_000);

    return () => {
      events.forEach((e) => window.removeEventListener(e, updateActivity));
      clearInterval(heartbeatIntervalRef.current);
      clearInterval(checkIntervalRef.current);
    };
  }, [token]);
};
